import { EDA } from "motw_core/Dreams/EDreamAttribute";
import IDream from "motw_core/Entity/IDream";
import { dreamService } from "motw_core/Services/DreamService";
import * as React from "react";
import { CanDreamBeRemoved } from "source/app/presentation/MainPanel/Dreams/Controls/DreamControls";
import { DreamTooDifficultSymbol } from "source/app/presentation/MainPanel/Dreams/InfoIcon/IsActionable/DreamTooDifficultSymbol";
import { DecisionTimeLeftBadge } from "source/app/presentation/MainPanel/Dreams/InfoIcon/TimeLeftBadge/DecisionTimeLeftBadge";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { useIntervalToRerender } from "source/app/services/Shared/Hooks/useIntervalToRerender";
import { ProblemDreamMissingHashTag } from "./IsActionable/ProblemDreamMissingHashTag";
import { hashTagsService } from "motw_core/Services/HashTagsService";

export function DreamInfoIcons({
    dream,
    isShowingQuickSelector,
}: {
    dream: IDream;
    isShowingQuickSelector: boolean;
}) {
    if (isShowingQuickSelector) {
        return null;
    }

    const canDisplayInfoIcons =
        dreamService.DoesDreamHaveAttribute(dream, EDA.decision) ||
        dreamService.DoesDreamHaveAttribute(dream, EDA.problem);

    // This condition is not part of the "renderables" array below, to speed up calculations
    if (!canDisplayInfoIcons) {
        return null;
    }

    useIntervalToRerender(60000);
    const dreamAgeInMinutes = dreamService.GetDreamAgeInMinutes(dream);
    const isDreamOldEnough = IsDreamOldEnough(dreamAgeInMinutes);

    const renderables = [
        {
            condition:
                canDisplayInfoIcons &&
                !CanDreamBeRemoved(dream) &&
                !IsDreamDifficultyActionable(dream),
            toRender: <DreamTooDifficultSymbol />,
        },
        {
            condition:
                canDisplayInfoIcons &&
                !isDreamOldEnough &&
                !CanDreamBeRemoved(dream) &&
                dreamService.DoesDreamHaveAttribute(dream, EDA.decision),
            toRender: (
                <DecisionTimeLeftBadge dreamAgeInMinutes={dreamAgeInMinutes} />
            ),
        },
        {
            condition:
                dreamService.DoesDreamHaveAttribute(dream, EDA.problem) &&
                !hashTagsService.DoesDreamHaveAnyProblemHashTags(dream),
            toRender: <ProblemDreamMissingHashTag />,
        },
    ];

    const validRenderables = renderables.filter(
        (renderable) => renderable.condition
    );

    if (validRenderables.length === 0) {
        return null;
    }

    const toRender = validRenderables.map((renderable, index) =>
        Object.assign({}, renderable.toRender, { key: index })
    );

    return (
        <span
            className={StyleClass(`dreamInfoIcon_spacing`, {
                marginRight: `10px`,
            })}
        >
            {toRender}
        </span>
    );
}

export const minGoodAgeForDreamInMinutes = 60;

function IsDreamOldEnough(dreamAgeInMinutes: number) {
    return dreamAgeInMinutes >= minGoodAgeForDreamInMinutes;
}

function IsDreamDifficultyActionable(dream: IDream) {
    return dream.difficulty <= 6;
}
